import { Types } from '../../../constants';
import { WrapHelper } from '../WrapHelper';
export class WrapBooleanHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Boolean;
    }
}

//# sourceMappingURL=WrapBooleanHelper.js.map
